export function getStringWithVariables(object: any, stringToReplace: string | boolean): string | false {
  const keys = ['slug', 'id']
  if (!stringToReplace)
    return false
  keys.forEach((key) => {
    const placeholder = `%${key}`
    if (object.hasOwnProperty(key)) {
      stringToReplace = stringToReplace.replace(new RegExp(placeholder, 'g'), object[key])
    }
    else {
      return false
    }
  })
  return stringToReplace as string
}

export function getPriceString(priceInPence?: number): string {
  if (!priceInPence || priceInPence === 0) {
    return 'Free'
  }
  return `£${(priceInPence / 100).toLocaleString('en-UK', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`
}

export function readUploadedFileAsImage(inputFile: File): Promise<ImagePreview> {
  const temporaryFileReader = new FileReader()
  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort()
      reject({ type: 'error', src: '' })
    }

    temporaryFileReader.onload = (image) => {
      resolve({ type: 'file', src: image?.target?.result as string })
    }

    temporaryFileReader.readAsDataURL(inputFile)
  })
}

export function formatDate(input: string | null | undefined): string {
  // Return an empty string if the input is null, undefined, or empty
  if (!input) {
    return ''
  }

  // Parse the input date string into a Date object
  const date = new Date(input)

  // Check if the date is valid
  if (Number.isNaN(date.getTime())) {
    return ''
  }

  // Extract date components
  const hours = date.getUTCHours()
  const minutes = date.getUTCMinutes()
  const day = date.getUTCDate()
  const month = date.getUTCMonth() + 1 // Months are zero-based
  const year = date.getUTCFullYear()

  // Format hours and minutes
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12
  const formattedMinutes = minutes.toString().padStart(2, '0')
  const ampm = hours < 12 ? 'am' : 'pm'

  // Format day, month, and year
  const formattedDay = day.toString().padStart(2, '0')
  const formattedMonth = month.toString().padStart(2, '0')
  const formattedYear = year

  // Combine into final format
  return `${formattedHours}:${formattedMinutes}${ampm} ${formattedDay}/${formattedMonth}/${formattedYear}`
}

export function normalizeNewlines(text?: string): string {
  if (!text)
    return ''
  if (typeof text !== 'string') {
    return text
  }
  // Replace all occurrences of \n (LF) not preceded by \r (CR) with \r\n
  return text.replace(/([^\r])\n/g, '$1\r\n')
}

export function normalizeDescriptionForCards(text?: string): string {
  const description = normalizeNewlines(text)
  return description.replace(/<img\b[^>]*>/gi, '')
}

export function getButtonColor(background: 'blue' | 'light-blue' | 'pink' | undefined): { button: string, icon: string } {
  if (background === 'blue') {
    return { button: 'pink', icon: 'text-yellow' }
  }
  if (background === 'light-blue') {
    return { button: 'yellow', icon: 'text-primary' }
  }
  if (background === 'pink') {
    return { button: 'blue', icon: 'text-yellow' }
  }
  return { button: 'blue', icon: 'text-yellow' }
}

const colors = [
  'text-lightblue', 'text-yellow', 'text-pink',
]

export function getColor(index: number) {
  return colors[index % colors.length]
}

export function isOdd(num: number) {
  return num % 2
}
export function getPosition(index: number) {
  return isOdd(index) ? 'left-[2%]' : 'right-[2%]'
}
